import { useMutation, useQueryClient } from '@tanstack/react-query';

import { signedApi } from '@/api/routes/common/signed.api';

export const useLogout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => signedApi.logout(),
    onSuccess: () => {
      // Clear all queries from cache on logout
      queryClient.clear();
    },
  });
};
